import React, { useEffect, useState } from "react";
import { postAPICall } from "../Api/Api";
import { Card, Row, Col, Container } from "react-bootstrap";
import { Dialog } from "primereact/dialog"; // Import PrimeReact Dialog
import { useNavigate } from "react-router-dom";
import "./ChannelPopup.css";
// import DailywatchLogo from "../Images/DailywatchLogo.png";
import ibacoLogo from "../Images/ibaco-final-logo.jpg";
import HapPlants from "../Images/HapPlants .jpg";
// import dailywatchLogo from "../Images/DailywatchLogo.png";
import hapDailyImage from "../Images/HAP Daily.jpg";

const DailywatchLogo = [ibacoLogo, hapDailyImage, hapDailyImage, HapPlants];

export default function ChannelPopup() {
  const [accountGroupType, setAccountGroupType] = useState([]);
  const [visible, setVisible] = useState(true); // State for controlling visibility

  useEffect(() => {
    fetchAccountGroupType();
  }, [localStorage.getItem("JWtAccessToken")]);

  let navigate = useNavigate();

  const fetchAccountGroupType = async () => {
    try {
      let NewUserId = localStorage.getItem("GetUserId");
      const requestBody = {
        UserId: NewUserId,
      };
      const response = await postAPICall(
        "api/AccountGroup/GetAccountGroup",
        requestBody
      );
      if (localStorage.getItem("Loginusertype") === "Administration") {
        const filteredData = response?.data;
        setAccountGroupType(filteredData);
      } else {
        const filteredData = response?.data?.filter(
          (item) => item.UserId !== null
        );
        setAccountGroupType(filteredData);
      }
    } catch (error) {}
  };

  const OnCellClick = (e) => {
  
    localStorage.removeItem("Value");
    if (e.target.nextSibling != null) {
      if (e.target.nextSibling.children.popupImgLogoNmae == null) {
        const nextSibling = e.target.nextSibling;
        const AccountGroupCode =
          nextSibling.children.length === 0
            ? nextSibling.innerHTML
            : nextSibling.children.AccountGroupCode.textContent;
        localStorage.setItem("AccountGroupCode", AccountGroupCode);

        const NoOfDays =
        nextSibling.children.length === 0
          ? nextSibling.innerHTML
          : nextSibling.children.Days.textContent;
      localStorage.setItem("SelectedAccountGroupAgainstDays", NoOfDays); 
        const ChannelName =
          nextSibling.children.length === 0
            ? nextSibling.previousElementSibling.innerHTML
            : nextSibling.children.ChannelName.textContent;
        localStorage.setItem("ChannelName", ChannelName);
        navigate("/schedule");

      
      }

    }
  };

  const handleCloseClick = () => {
    if (localStorage.getItem("Loginusertype") == "Administration") {
      navigate("/masterLayout");
    } else {
      navigate("/");
    }
  };

  return (
    <div>
      <Dialog
        visible={visible}
        onHide={handleCloseClick}
        header="Channel Name"
        className="Dialogue-container"
        closable={localStorage.getItem("Detail") === "1" ? false : true}
        style={{ width: "800px" }}
        draggable={false}
      >
        <Container>
          <Row className="Container" onClick={OnCellClick}>
            {accountGroupType &&
              accountGroupType.map((accountGroupType, index) => (
                <Col
                  key={index}
                  xs={12} // 12 columns on extra small screens
                  sm={6} // 6 columns on small screens
                  md={4} // 4 columns on medium screens
                  lg={3} // 3 columns on large screens
                  style={{ padding: "10px" }}
                >
                  <Card id="popupImgLogoNmae">
                    <Card.Img
                      id="imgLogo"
                      src={DailywatchLogo[index % DailywatchLogo.length]}
                      alt="Image"
                    />
                    <Card.Body>
                      <Card.Title id="ChannelName">
                        {accountGroupType.AccountGroupName}
                      </Card.Title>
                      <Card.Title id="AccountGroupCode" hidden>
                        {accountGroupType.AccountGroupCode}
                      </Card.Title>
                      <Card.Title id="Days" hidden>
                        {accountGroupType.Days}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
          </Row>
        </Container>
      </Dialog>
    </div>
  );
}
